
import { HttpClient } from '@angular/common/http'; import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { QuoteService } from 'src/app/service/quote.service';
//import { SelectItemModel } from 'src/app/models/select-item'
import { Country } from 'src/app/models/country.model';
import { GetQuoteRatesRequestModel, GetQuoteResponseModel, SendQuoteByEmailModel } from 'src/app/service/web-api-client';

@Component({
  selector: 'quote-step6',
  templateUrl: 'quote-step6.component.html',
  styleUrls: ['quote-step6.component.css'],
})
export class QuoteStep6Component implements OnInit{
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  isSectionVisible: boolean = false; // Initially hidden

  toggleSection() {
    this.isSectionVisible = !this.isSectionVisible; // Toggle visibility
  }
  
  countries: Country[] = [];
  selectedCountry: Country | null;
  filterValue: string = '';

  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  progressBarPath: string = '/assets/external/Progress-bar.svg'
  progressBarTransparentPath: string = '/assets/external/Progress-bar-transparent.svg'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectoralt: string = 'Vector3387'
  vectoralt4: string = 'Vector3387'
  ballPink1src: string = '/assets/external/basketball-resize.png'
  ballPink1alt: string = 'BallPink13179'
  towerGrey: string = '/assets/external/tower-resize.png'
  plusFilled: string = '/assets/external/plusFilled.png'
  
  stepThreeForm: FormGroup;
  submitted = false;

  readonly _coverage50k: number = 50000;
  readonly _coverage100k: number = 100000;
  readonly _coverage250k: number = 250000;

  travelDuration: number = 0;
  dependentCount: number = 0;
  dependentCountOver65: number = 0;
  residenceCountry: string = null;
  destinationRegion: string = null;
  agencyName: string = "Blue Assist";
  checked: boolean = false;

  model50k: GetQuoteResponseModel = new GetQuoteResponseModel();
  model100k: GetQuoteResponseModel = new GetQuoteResponseModel();
  model250k: GetQuoteResponseModel = new GetQuoteResponseModel();
  coverageSelected: number;

  sendQuoteByEmailForm: FormGroup;

  isBusy: boolean = false;
  emailSendingStatus: number = 0;
  
  constructor(public quoteService: QuoteService, private http: HttpClient, private fb: FormBuilder,
  
  ) {  

    this.createForm();

    const json: string = JSON.stringify(this.quoteService.quoteModel);
    // this.coverageSelected = this.quoteService.quoteModel?.maxCoverage?.value ?? 0;
    if(this.coverageSelected == this._coverage50k) {
      this.model50k = JSON.parse(json);
    } else if(this.coverageSelected == this._coverage100k) {
      this.model100k = JSON.parse(json);
    }
    else if(this.coverageSelected == this._coverage250k) {
      this.model250k = JSON.parse(json);
    }
    else {
      console.error('Coverage not supported');
    }
  }

  nextStep(): void {
		 this.onNextStep.emit(this.currentStep);
	}

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
 }

  ngOnInit() {
    this.emailSendingStatus = 0;

    this.travelDuration = this.quoteService.quoteModel?.durationInDays ?? 0;
    this.dependentCount = this.quoteService.quoteModel?.dependentCount ?? 0;
    this.dependentCountOver65 = this.quoteService.quoteModel?.dependentCountOver65 ?? 0;
    
    const self = this;
    this.quoteService.getCountries$().subscribe(allCountries => {
        const country = allCountries.find(c => c.id == self.quoteService.quoteModel?.residenceCountryId);
        if(country) {
          self.residenceCountry = country.name;
        }
    });
  
    this.quoteService.getRegions$().subscribe(allRegions => {
      const region = allRegions.find(r => r.id == self.quoteService.quoteModel?.destinationRegionId);
      if(region) {
        self.destinationRegion = region.name;
      }
    });
   

    const json: string = JSON.stringify(this.quoteService.quoteModel);
    let request1: GetQuoteRatesRequestModel = JSON.parse(json);
    let request2: GetQuoteRatesRequestModel = JSON.parse(json);

    if(this.coverageSelected == this._coverage50k) {
      // request1.maxCoverage.value = this._coverage100k;
      // request2.maxCoverage.value = this._coverage250k;
    } else if(this.coverageSelected == this._coverage100k) {
      // request1.maxCoverage.value = this._coverage50k;
      // request2.maxCoverage.value = this._coverage250k;
    }
    else if(this.coverageSelected == this._coverage250k) {
      // request1.maxCoverage.value = this._coverage50k;
      // request2.maxCoverage.value = this._coverage100k;
    }
    else {
      return;
    }

    const task1 = this.quoteService.getRates$(request1);
    const task2 = this.quoteService.getRates$(request2);

    forkJoin([task1, task2]).subscribe(results => {
      const result1 = results[0];
      const result2 = results[1];

      if(this.coverageSelected == this._coverage50k) {
        this.model100k = result1;
        this.model250k = result2;
      } else if(this.coverageSelected == this._coverage100k) {
        this.model50k = result1;
        this.model250k = result2;
      }
      else if(this.coverageSelected == this._coverage250k) {
        this.model50k = result1;
        this.model100k = result2;
      }
    }, error => {
      console.error(error);
    });
  }

  downloadQuotePdf(): void {
    if(this.isBusy) {
      return;
    }
    this.isBusy = true;

    let request: GetQuoteResponseModel = null;
    if(this.coverageSelected == this._coverage50k) {
      request = JSON.parse(JSON.stringify(this.model50k));
    } else if(this.coverageSelected == this._coverage100k) {
      request = JSON.parse(JSON.stringify(this.model100k));
    }
    else if(this.coverageSelected == this._coverage250k) {
      request = JSON.parse(JSON.stringify(this.model250k));
    }

    const self = this;
    this.quoteService.downloadQuoteDocument(request.number)
      .subscribe(file => {
        self.isBusy = false;

        //const blob = new Blob([file.], { type: 'application/json' }); 
        const objectUrl: string = window.URL.createObjectURL(file.data);

        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        a.href = objectUrl;
        a.download = file.fileName ?? 'quote.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);

      }, error => {
          self.isBusy = false;
          console.log('Error Downloading Document');
          console.error(error);
      });
  }

  createForm(): void {
    this.sendQuoteByEmailForm = this.fb.group({
      optionalRecipients: ['']
    });
    this.http.get<Country[]>('/assets/countrycode/CountryCodes.json').subscribe(data => {
      this.countries = data.map(country => {
        return {
          name: country.name,
          code: country.code,
          phoneCode: country.phoneCode,
          flag: country.flag,
          id: country.phoneCode,
          text: country.name
        };
      });
    });
  }

  sendEmail(): void {
    if(this.isBusy) {
      return;
    }
    this.isBusy = true;
    this.emailSendingStatus = 1;


    const json: string = JSON.stringify(this.quoteService.quoteModel);
    let quoteModel: GetQuoteResponseModel = JSON.parse(json);

    const request = new SendQuoteByEmailModel({
      recipientEmails: this.sendQuoteByEmailForm.controls.optionalRecipients.value,
      quoteModel: quoteModel
    });

    const self = this;
    self.quoteService.sendQuoteByEmail$(request)
      .subscribe(success => {
        console.log('sending Email result: ', success);
        self.isBusy = false;
        self.emailSendingStatus = success
          ? 2
          : 3;
      }, error => {
        console.error('Error sending quote by email');
      });
  }

  get canContinue(): boolean {
    return this.sendQuoteByEmailForm.valid && this.validateRecipients(this.sendQuoteByEmailForm.controls.optionalRecipients.value) && this.isBusy != true && this.emailSendingStatus == 0;
  }

  private validateRecipients(value: string): boolean {
    if(!value) {
      return true;
    }
    
    let recipients = value
      .replace(' ', '')
      .replace(';', ',')
      .split(",");

    if(recipients.length == 0) {
      return true;
    }

    for(let email of recipients) {
      var isValid = this.validateEmail(email);
      if(!isValid) {
        return false;
      }
    }

    return true;
  }

  private validateEmail(email: string): boolean {
    let res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(email);
  }
}
